import { BaseClient } from '../client';

export const putAdminGroupLogo = async (groupId: string, file: File) => {
	// if (process.env.NODE_ENV === 'development') {
	// 	return 'Cadastrado com sucesso';
	// }

	try {
		const formData = new FormData();
		formData.append('file', file);

		const response = await BaseClient.post<string>(
			`/Admin/UpdateAdminGrupoConcessionariaFoto/${groupId}`,
			formData,
			{
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			}
		)
		

		return response;
	} catch (error) {
		throw error;
	}
};
